// Vendor imports
const _ = require('lodash')

/**
 * Used by the `branch_params` field of `client_session` data
 * @returns {Object} Business Event Branch parameters
 * @see https://docs.branch.io/web/integrate/#initialize-branch-features
 * @see https://github.com/mix/mix/blob/master/app/views/partials/scripts/branch.pug
 */
function getBusinessEventParams() {
  return {
    ..._.get(window, 'branchInitData.data_parsed', {}),
    'branch_identity_id': (
      _.get(window, 'branchIdentity.identity_id') ||
      _.get(window, 'branchInitData.identity')
    )
  }
}

module.exports = {
  getBusinessEventParams
}
